import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {TheRave} from "../TheRave";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class TheRaveIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.4, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xWays: true,
        xSplit: true,
        xBet: true,
        volatility: Volatility.EXTREME
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    constructor() {
    }

    public gameClientConfigurationApplied(): void {

    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/introBG.jpg");
        imgLoader.add("introLogo", "resources/images/introLogo.png");
        imgLoader.add("introBorder", "resources/images/introBorder.png");
        imgLoader.add("introBorderTop", "resources/images/Intro_Divider_up.png");
        imgLoader.add("introBorderBottom", "resources/images/Intro_Divider_down.png");
        imgLoader.add("PhotosensitivityWarning", "resources/images/PhotosensitivityWarning.png");
        imgLoader.add("feature1", "resources/images/xWays.png");
        imgLoader.add("feature1_US", "resources/images/xWays_US.png");
        imgLoader.add("feature2", "resources/images/specialSym.png");
        imgLoader.add("feature3", "resources/images/xSplit.png");
        imgLoader.add("feature4", "resources/images/murderonthedancefloor.png");
        imgLoader.add("xbet", "resources/images/xbet.png");
        imgLoader.add("woofer", "resources/images/woofer.png");
        imgLoader.add("eqBg", "resources/images/winAmpBg.png");
        imgLoader.add("eqGreen", "resources/images/greenMeter.png");
        imgLoader.add("eqYellow", "resources/images/yellowMeter.png");
        imgLoader.add("eqRed", "resources/images/redMeter.png");
        imgLoader.add("dxWild", "resources/images/dxWild.png");
        imgLoader.add("dxWays", "resources/images/dxWays.png");
        imgLoader.add("xBetActive", "resources/images/active.png");
        imgLoader.add("xBetInactive", "resources/images/inactive.png");
        imgLoader.add("ROLLING", "resources/images/ROLLING.png");



        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        return new Promise((resolve, reject) => {
            this.background = new PIXI.Container();
            const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
            bgSprite.anchor.set(0.5, 0.5);
            const fence = new PIXI.Sprite(ImgLoader.getImgTexture("introBorder"));
            fence.anchor.set(0.5, 0.5);
            fence.position.y = -35;
            this.background.addChild(bgSprite);
            this.background.addChild(fence);

            this.borderTop = new PIXI.Container();
            const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBorderTop"));
            topSprite.name = "top";
            topSprite.anchor.set(0.5, 0.5);
            topSprite.position.y = 9;
            this.borderTop.addChild(topSprite);

            this.borderBottom = new PIXI.Container();
            const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBorderBottom"));
            bottomSprite.anchor.set(0.5, 0.5);
            bottomSprite.name = "bottom";
            bottomSprite.position.y = 18;
            this.borderBottom.addChild(bottomSprite);

            this.logo = new PIXI.Container();
            const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introLogo"));
            logoSprite.anchor.set(0.5, 0.5);
            this.logo.addChild(logoSprite);

            const featureSprite1 = new PIXI.Sprite(ImgLoader.getImgTexture("feature1"));
            featureSprite1.name = "feature1";
            featureSprite1.anchor.set(0.5, 0.5);

            const featureSprite2 = new PIXI.Sprite(ImgLoader.getImgTexture("feature2"));
            featureSprite2.name = "feature2";
            featureSprite2.anchor.set(0.5, 0.5);

            const featureSprite3 = new PIXI.Sprite(ImgLoader.getImgTexture("feature3"));
            featureSprite3.name = "feature3";
            featureSprite3.anchor.set(0.5, 0.5);

            const featureSprite4 = new PIXI.Sprite(ImgLoader.getImgTexture("feature4"));
            featureSprite4.name = "feature4";
            featureSprite4.anchor.set(0.5, 0.5);

            this.pages = [
                new SlideShowPage(),
                new SlideShowPage(),
                new SlideShowPage(),
                new SlideShowPage(),
            ];

            this.pages[0].addChild(featureSprite1);
            this.pages[1].addChild(featureSprite2);
            this.pages[2].addChild(featureSprite3);
            this.pages[3].addChild(featureSprite4);


            if (TheRave.apiPlugin.gameClientConfiguration.isSet) {
                this.checkBoostedBetAndMultiplierImage();
                resolve(this);
            } else {
                TheRave.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                    this.checkBoostedBetAndMultiplierImage();
                    resolve(this);
                });
            }
        });
    }

    private addBoostPage() {
        const xbetSprite = new PIXI.Sprite(ImgLoader.getImgTexture("xbet"));
        xbetSprite.anchor.set(0.5, 0.5);
        const page = new SlideShowPage();
        page.addChild(xbetSprite)
        this.pages.splice(1, 0, page);
    }

    private addWarningPage() {
        const warningSprite = new PIXI.Sprite(ImgLoader.getImgTexture("PhotosensitivityWarning"));
        warningSprite.anchor.set(0.5, 0.5);
        const page = new SlideShowPage();
        page.addChild(warningSprite)
        this.pages.splice(0, 0, page);
    }

    private showMultiplierImage() {
        if (!TheRave.apiPlugin.gameClientConfiguration.showLowProbabilityGfx) {
            for (let i: number = 0; i < this.pages.length; i++) {
                if (this.pages[i].children[0].name === "feature1") {
                    (<PIXI.Sprite>this.pages[i].children[0]).texture = ImgLoader.getImgTexture("feature1_US");
                }
            }
        }
    }

    private checkBoostedBetAndMultiplierImage():void{
        if (TheRave.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
            if(!TheRave.isNJServer){
                this.addBoostPage();
            }else{
                this.stampConfig.xBet = false;
            }
            this.addWarningPage();
        }else{
            this.stampConfig.xBet = false;
        }
        this.showMultiplierImage();
    }
}